module.exports = {
    "collapse": `Daralt`,
    "expand": `Geni\u{15F}let`
};


//# sourceMappingURL=tr-TR.main.js.map
